<template>
  <div id="app" class="app-container">
    <header class="app-header">
      <a href="#main" class="sr-only sr-only-focusable" >Skip to main content</a>
      <AppNavBar />
      <div v-show="showSessionReminder">
        <div class="border rounded p-2 bg-warning d-flex justify-content-center align-items-center" >
          <div>
            <strong>Session Timeout: </strong><span class="mx-2">Your session will timout in</span>      
          </div>
          <strong><Vidle v-show="showSessionReminder"
                         @idle="onidle"
                         @remind="onRemind"
                         @refresh="onRefresh"
                         :duration=timeoutDuration
                         :reminders=reminders /> 
          </strong>                     
        </div>        
      </div>
    </header>
    <main id="main" role="main" class="app-content">
      <Toast group="top-toast" position="top-center"/>
      <MnConfirmDialog />
      <MnAlertDialog />
      <RouterView />

    </main>
    <Teleport to="body">
      <MnLoader :visible="loadingState.loading" :message="loadingState.loadingMessage" /> 
    </Teleport>           
  </div>
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { ref, onMounted, watch } from 'vue';
import { RouterView } from 'vue-router';

// Components
import AppNavBar from '@/components/menu/AppNavBar.vue';
import Vidle from 'v-idle';
import Toast from 'primevue/toast';
import MnAlertDialog from './components/common/MnAlertDialog.vue';
import MnLoader from './components/common/MnLoader.vue';
import MnConfirmDialog from './components/common/MnConfirmDialog.vue';

// Composables


// Stores
import { useAuthStore } from './stores/authStore';
import { useAppStore } from './stores/appStore';

// Constants and Utils


// ===============================
// PROPS & EMITS
// ===============================


// ===============================
// COMPOSABLES & STORES
// ===============================
const authStore = useAuthStore();
const appStore = useAppStore();
const { loadingState } = appStore;

// ===============================
// REACTIVE STATE
// ===============================


// ===============================
// CONSTANTS
// ===============================
// User is only reminded 120 seconds before the session expires.
const reminders = [120];
// The session timeout duration is set to 20 minutes.
const timeoutDuration = parseInt(import.meta.env.VITE_APP_TIMEOUT);
const showSessionReminder = ref(false);


// ===============================
// COMPUTED PROPERTIES
// ===============================


// ===============================
// METHODS
// ===============================

/**
 * Executes the specified callback function when the user is idle.
 * 
 * @param {Function} callback - The callback function to execute when the user is idle.
 * @returns {void}
 */
const onidle = () => {
  if (authStore.authenticated) {
    authStore.logout();
    localStorage.removeItem('txStore');
  }
};
/**
 * Handles the onRemind event.
 * This function sends a reminder to the user.
 * @param {string} message - The reminder message.
 * @returns {void}
 */
const onRemind = () => {
  if (authStore.authenticated) {
    showSessionReminder.value = true;
  }
};

/**
 * Handles the onRefresh event.
 * This function refreshes the data on the page.
 * @returns {void}
 */
const onRefresh = () => {
  showSessionReminder.value = false;
};

// ===============================
// WATCHERS
// ===============================


// ===============================
// LIFECYCLE HOOKS
// ===============================
onMounted(() => {
  watch(
    () => authStore.authenticated,
    async (authenticated) => {
      if (authenticated) {
        try {
          await appStore.initializeStore();
        } catch (error) {
          console.error('Error initializing app store:', error);
        }
      }
    },
    { immediate: true } // Triggers the watcher immediately upon setup
  );

});


// ===============================
// EXPOSE
// ===============================

</script>
<style>
.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.app-header {
  flex-shrink: 0;
}

.app-content {
  padding: 1rem;
  flex-grow: 1;
  overflow-y: auto;
}
</style>



